import CopyIcon from "@/assets/img/symbolic/copy.svg?react";
import ReportIcon from "@/assets/img/symbolic/report.svg?react";
import React from "react";
import { twMerge } from "tailwind-merge";

// Global context menu manager
const contextMenuManager = {
    activeMenus: new Set<() => void>(),

    register(closeCallback: () => void)
    {
        // Close all existing menus before registering the new one
        this.activeMenus.forEach(callback => void callback());
        this.activeMenus.clear();
        // Register the new menu
        this.activeMenus.add(closeCallback);
    },

    unregister(closeCallback: () => void)
    {
        this.activeMenus.delete(closeCallback);
    },

    closeAll()
    {
        this.activeMenus.forEach(callback => void callback());
        this.activeMenus.clear();
    }
};

const ChatContextMenu = ({
    own,
    close,
    onCopy,
    onReport,
}: {
    own: boolean;
    close: () => void;
    onCopy: () => void;
    onReport: () => void;
}) =>
{
    const iconStyles = Wind.style({
        color: "text-[#6784B0]",
        width: "w-4",
        height: "h-4",
        marginRight: "mr-1"
    }).class;

    const buttonStyles = Wind.style({
        display: "flex",
        alignItems: "items-center",
        justifyContent: "justify-start",
        padding: "p-1",
        paddingRight: "pr-0",
        width: "w-[100%]",
        height: "h-full"

    }).class;


    // Register this context menu with the global manager and create a mouse listener to close it when clicking outside
    React.useEffect(() =>
    {
        // Register this menu with the global manager (this will close other menus)
        contextMenuManager.register(close);

        const listener = (e: MouseEvent) =>
        {
            if (!(e.target as HTMLElement).closest(".context-menu"))
            {
                e.stopPropagation();
                close();
            }
        };

        document.addEventListener("click", listener);

        return () =>
        {
            document.removeEventListener("click", listener);
            contextMenuManager.unregister(close);
        };
    }, [close]);

    return (
        <nav
            aria-label="context menu"
            className={twMerge(
                "context-menu",
                Wind.style({
                    backgroundColor: "bg-[#1B2F4E]",
                    color: "text-white",
                    fontSize: "text-xs",
                    borderRadius: "rounded",
                    padding: "p-1",
                    width: "w-32",
                    position: "absolute",
                    zIndex: "z-50",
                    boxShadow: "shadow-md",
                    boxShadowColor: "shadow-[rgba(0,0,0,0.35)]",
                    right: own ? "right-2" : "right-[unset]",
                    left: own ? "left-[unset]" : "left-11",
                }).class
            )}
            style={{
                top: "calc(100%)",
            }}
        >
            <ul className="chat-context-menu__items">
                <li className="chat-context-menu__item">
                    <button
                        className={buttonStyles}
                        onClick={onCopy}
                    >
                        <CopyIcon
                            className={iconStyles}
                            aria-hidden="true"
                        />
                        {" "}
                        <span>Copy Text</span>
                    </button>
                </li>
                <li className="chat-context-menu__item">

                    <button
                        className={buttonStyles}
                        onClick={onReport}
                    >
                        <ReportIcon
                            className={iconStyles}
                            aria-hidden="true"
                        />
                        {" "}
                        Report
                    </button>
                </li>
            </ul>
        </nav>

    );
};

export default ChatContextMenu;
